import { Button, Grid2, InputBase } from '@mui/material';

interface ProductSearchInputProps {
    onSearch: () => void;
    onInputChange: (value: string) => void;
    errorMessage?: string;
}

const ProductSearchInput = ({ onSearch, onInputChange, errorMessage }: ProductSearchInputProps) => {
    return (
        <>
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <Grid2 container>
                        <Grid2 size={{ xs: 9 }}>
                            <InputBase
                                fullWidth
                                autoComplete="off"
                                name="primaryProduct"
                                data-testid="product-input-wrapper"
                                className={`form-input-group ${errorMessage ? 'input-error' : ''}`}
                                onChange={(input) => {
                                    return onInputChange(input.target.value);
                                }}
                                sx={{
                                    height: '100%',
                                    padding: '10px',
                                    border: '1px solid #ccc',
                                    borderRight: 'none',
                                    borderRadius: '4px 0 0 4px',
                                    boxSizing: 'border-box',
                                }}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 3 }}>
                            <Button
                                fullWidth
                                variant="outlined"
                                onClick={onSearch}
                                className={`btn-input-group btn-primary ${
                                    errorMessage ? 'btn-error' : ''
                                }`}
                                sx={{
                                    height: '100%',
                                    borderTopLeftRadius: 0,
                                    borderBottomLeftRadius: 0,
                                }}
                            >
                                Search
                            </Button>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>
            {errorMessage && <label className="error">{errorMessage}</label>}
        </>
    );
};

export default ProductSearchInput;
